const PROPERTY_OWNER_RENT_PATH = '/private-anbieter/eigentuemer/vermieten'
const PROPERTY_OWNER_SELL_PATH = '/private-anbieter/eigentuemer/verkaufen'
const TENANT_RENT_PATH = '/private-anbieter/mieter/vermieten'
const AGENT_RENT_PATH = '/profi-anbieter/vermieten'
const AGENT_WAITING_LIST_PATH = '/profi-anbieter/warteliste/vermieten'
const AGENT_SELL_PATH = '/profi-anbieter/verkaufen'
export const BASE_PATH = '/'

//property_owner_rent_paths
export const PROPERTY_OWNER_APARTMENT_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/wohnung`
export const PROPERTY_OWNER_OFFICE_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/buero`
export const PROPERTY_OWNER_HOUSE_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/haus`
export const PROPERTY_OWNER_GASTRONOMY_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/gastronomie`
export const PROPERTY_OWNER_HANGAR_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/halle`
export const PROPERTY_OWNER_STORE_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/einzelhandel`
export const PROPERTY_OWNER_GARAGE_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/garage`
export const PROPERTY_OWNER_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/befristete-immobilie`
export const PROPERTY_OWNER_INDUSTRIAL_PLOT_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/gewerbegrundstueck`

//property_owner_sell_paths
export const PROPERTY_OWNER_APARTMENT_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/wohnung`
export const PROPERTY_OWNER_OFFICE_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/buero`
export const PROPERTY_OWNER_HOUSE_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/haus`
export const PROPERTY_OWNER_PLOT_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/grundstueck`
export const PROPERTY_OWNER_INDUSTRIAL_PLOT_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/gewerbegrundstueck`
export const PROPERTY_OWNER_GASTRONOMY_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/gastronomie`
export const PROPERTY_OWNER_HANGAR_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/halle`
export const PROPERTY_OWNER_STORE_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/einzelhandel`
export const PROPERTY_OWNER_INVESTMENT_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/anlageobjekt`
export const PROPERTY_OWNER_GARAGE_SELL_FLOW_PATH = `${PROPERTY_OWNER_SELL_PATH}/garage`

//tenant_rent_paths
export const TENANT_APARTMENT_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/wohnung`
export const TENANT_OFFICE_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/buero`
export const TENANT_HOUSE_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/haus`
export const TENANT_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/befristete-immobilie`
export const TENANT_GARAGE_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/garage`
export const TENANT_GASTRONOMY_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/gastronomie`
export const TENANT_STORE_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/einzelhandel`
export const TENANT_HANGAR_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/halle`
export const TENANT_FLAT_SHARE_ROOM_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/wg`
export const TENANT_INDUSTRIAL_PLOT_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/gewerbegrundstueck`

//professional_rent_paths
export const AGENT_APARTMENT_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/wohnung`
export const AGENT_FLAT_SHARE_ROOM_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/wg`
export const AGENT_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/befristete-immobilie`
export const AGENT_GARAGE_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/garage`
export const AGENT_HOUSE_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/haus`
export const AGENT_OFFICE_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/buero`
export const AGENT_GASTRONOMY_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/gastronomie`
export const AGENT_STORE_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/einzelhandel`
export const AGENT_PRODUCTION_HALL_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/halle`
export const AGENT_INDUSTRIAL_PLOT_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/gewerbegrundstueck`
export const AGENT_WAITING_LIST_APARTMENT_RENT_FLOW_PATH = `${AGENT_WAITING_LIST_PATH}/wohnung`

//professional_sell_paths
export const AGENT_HOUSE_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/haus`
export const AGENT_GASTRONOMY_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/gastronomie`
export const AGENT_OFFICE_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/buero`
export const AGENT_APARTMENT_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/wohnung`
export const AGENT_PRODUCTION_HALL_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/halle`
export const AGENT_INDUSTRIAL_PLOT_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/gewerbegrundstueck`
export const AGENT_PLOT_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/grundstueck`
export const AGENT_INVESTMENT_FLOW_PATH = `${AGENT_SELL_PATH}/anlageobjekt`
export const AGENT_STORE_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/einzelhandel`
export const AGENT_GARAGE_SELL_FLOW_PATH = `${AGENT_SELL_PATH}/garage`

//old paths

export const OLD_PROPERTY_OWNER_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${PROPERTY_OWNER_RENT_PATH}/moeblierte-immobilie`
export const OLD_TENANT_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${TENANT_RENT_PATH}/moeblierte-immobilie`
export const OLD_AGENT_SHORT_TERM_ACCOMMODATION_RENT_FLOW_PATH = `${AGENT_RENT_PATH}/moeblierte-immobilie`

export const ERROR_PATH = '/private-anbieter/error'
export const FORBIDDEN_PATH = '/private-anbieter/forbidden'
export const LISTING_DELETED_PATH = '/private-anbieter/listing-deleted'
export const SESSION_NOT_FOUND_PATH = '/private-anbieter/session-not-found'
export const LOGIN_PATH = '/login'
export const FLOW_CHOOSER_PATH = '/anbieten'
export const SEGMENTATION_PATH = '/start'
